<!--
 * @Author: xiaokun
 * @Date: 2020-04-11 10:29:35
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-12 14:21:45
 * @Description: 试题管理 左侧 分数设置
 -->
<template>
  <div class="left-score-setting border-attribute">
    <!-- 总题数 -->
    <div class="all-questions-number-line">
      总题数:
      <span class="num-color">{{ curTotalNumber }}</span> 题
    </div>
    <!-- 当前总数 -->
    <div class="cur-all-questions-number-line">
      当前总分:
      <span class="num-color">{{ curPaperTotalScore }}</span> 分
    </div>
    <!-- 分割线 -->
    <div class="line" />
    <!-- 通过分数 -->
    <div class="pass-score">
      通过分数:
      <el-input-number
        v-model="passScore"
        :step-strictly="true"
        :min="0"
        :controls="false"
      />分
    </div>
    <!-- 分割线 -->
    <div class="line" />
    <!-- 每题相同分 -->
    <div class="same-scroe">
      每题相同分:
      <el-switch
        v-model="sameScoreData.isSameScore"
        active-color="#009CFF"
        inactive-color="#BFBFBF"
        @change="handleSameScoreData"
      />
    </div>
    <!-- 每题 x 相同分 -->
    <div>
      <el-input-number
        v-model="sameScoreData.sameScoreNum"
        :disabled="!sameScoreData.isSameScore"
        class="same-score-input"
        :min="0"
        :max="100"
        :controls="false"
        :step-strictly="true"
        @change="handleSameScore"
      />分
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'LeftScoreSetting',
  components: {},
  props: {},
  data () {
    return {
      // 总题数
      questionNum: 0,
      // 通过分数
      passScore: undefined,

      sameScoreData: {
      // 是否每题分数相同
        isSameScore: false,
        // 相同分数
        sameScoreNum: undefined
      }
    }
  },
  computed: {
    // 当前总分数
    curPaperTotalScore () {
      return this.$store.state['examination-manage'].curPaperTotalScore
    },
    // 总题数
    curTotalNumber () {
      return this.$store.state['examination-manage'].curTotalNumber
    },
    curSameScore () {
      return this.$store.state['examination-manage'].curSameScore
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 存入实时 相同分
    ...mapMutations('examination-manage', {
      setCurSameScore: 'SET_CURSAMESCORE',
      setCurSameState: 'SET_CURSAMESTATE',
      setCurTotalNumber: 'SET_CURTOTALNUMBER'
    }),
    // 编辑时 父级数据回显
    setData (data) {
      this.questionNum = data.paperInfo.questionNum
      this.setCurTotalNumber(this.questionNum)
      this.passScore = data.paperInfo.passScore
    },
    handleSameScoreData (val) {
      this.setCurSameState(val)
      if (!val) {
        this.sameScoreData.sameScoreNum = undefined
      }
    },
    handleSameScore (val) {
      this.setCurSameScore(val)
    },
    // 返回通过分
    returnPassScore () {
      return this.passScore
    }
  }
}
</script>
<style lang='scss' scoped>
.left-score-setting {
  font-size: 13px;
  margin-right: 20px;
  padding: 15px 20px 18px 20px;
  line-height: 18px;
  height: 190px;

  /deep/.el-input-number {
    height: 28px;
    width: 50px;
    display: inline-block;
    margin-right: 5px;

    .el-input {
      height: 28px;
      width: 50px;
      display: inline-block;

      .el-input__inner {
        padding: 0;
        height: 28px;
        width: 50px;
      }
    }
  }

  /deep/ .same-score-input {
    width: 80px;

    .el-input {
      height: 28px;
      width: 80px;
      display: inline-block;

      .el-input__inner {
        width: 80px;
      }
    }
  }

  .num-color {
    color: #009cff;
  }

  .all-questions-number-line,
  .cur-all-questions-number-line {
    font-weight: 500;
    padding-bottom: 11px;
  }

  .pass-score {
    padding: 10px 0 15px;
  }

  .line {
    border-top: 1px dotted #d9d9d9;
    width: 144px;
  }

  .same-scroe {
    padding: 15px 0 12px;

    /deep/ .el-switch__core {
      width: 35px;
      transform: scale(0.8);
    }
  }
}
</style>
